module.exports = __webpack_public_path__ + "img/icon-copylink@2x.7c03d8af.png";